import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./../SkeletonCard/SkeletonCard.css";
import "./MovieCard.css"; 

const MovieCardOther = ({ movie }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [finalPosterUrl, setFinalPosterUrl] = useState("");

  const posterUrl = movie.poster_url.startsWith("http")
    ? movie.poster_url
    : `https://phimimg.com/${movie.poster_url}`;

  const handleImageLoad = () => {
    setIsLoading(false); 
  };

  useEffect(() => {
    const transformedPosterUrl = `https://img.vephim.online/?url=${posterUrl}&w=480&h=854&q=60&output=webp`;

    const checkImageUrl = async () => {
      try {
        const response = await fetch(transformedPosterUrl, { method: "HEAD" });
        if (response.ok) {
          setFinalPosterUrl(transformedPosterUrl);
        } else {
          setFinalPosterUrl(posterUrl); 
        }
      } catch (error) {
        setFinalPosterUrl(posterUrl); 
      } finally {
        setIsLoading(false);
      }
    };

    checkImageUrl();
  }, [posterUrl, movie.name]);

  return (
    <div
      className="movie-card"
    >
      <Link to={`/phim/${movie.slug}`}>
        <div
          className={`skeleton-image ${isLoading ? "loading" : ""}`}
          style={{ minHeight: "240px"}}
        >
          {isLoading ? (
            <div className="skeleton-image"
              style={{ minHeight: "200px", maxHeight: "240px", transition: "height 0.3s ease" }}>
              <img src="/logo-movie.svg" alt="" className="skeleton-logo" style={{width:"36px", height:"36px"}}/>
              <div className="waiting-text"></div>
            </div>
          ) : (
            <img
              src={finalPosterUrl}
              loading="lazy"
              alt={movie.name}
              onLoad={handleImageLoad} 
            />
          )}
        </div>
      </Link>
      <h3>{movie.name}</h3>
    </div>
  );
};

export default MovieCardOther;
